import { render, staticRenderFns } from "./UserSupport.vue?vue&type=template&id=41786119&scoped=true"
import script from "./UserSupport.vue?vue&type=script&lang=ts"
export * from "./UserSupport.vue?vue&type=script&lang=ts"
import style0 from "./UserSupport.vue?vue&type=style&index=0&id=41786119&prod&lang=scss"
import style1 from "./UserSupport.vue?vue&type=style&index=1&id=41786119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41786119",
  null
  
)

export default component.exports